import React from "react";
import PropTypes from "prop-types";

function Layout({ nextBillingDate, children }) {
  return (
    <div
      style={{ maxWidth: "650px", margin: "0px auto" }}
      data-test="summary-step"
    >
      {children}
      {nextBillingDate && (
        <div
          data-test="summary-disclaimer"
          style={{ marginTop: "1em", fontStyle: "italic", fontSize: "90%" }}
        >
          Next billing is on <b>{nextBillingDate}</b>. A prorated amount will be
          charged today, and an invoice will be emailed to you.
        </div>
      )}
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
  nextBillingDate: PropTypes.string,
};

Layout.defaultProps = { children: undefined, nextBillingDate: "" };

export default Layout;
